const hrmSupport = {
  id: `HRM`,
  text: `Your Dedicated HR Manager leads your strategic HR planning and operations, providing expert advice on complex issues. They align HR strategies with your business goals, offering comprehensive support and creative and tailored solutions across various aspects of human resources management to foster both a compliant and supportive organizational culture, showcasing Bambee's dedication to strategic HR leadership.`,
  notes: `Dedicated HR Manager`,
  list: [
    `Strategic HR Planning`,
    `Complex HR Issues`,
    `Employee Relations Guidance`,
    `Performance Management`,
    `Terminations Guidance`,
    `Wage and Hour Compliance`,
  ],
} as const;

export default hrmSupport;
